import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [un, setUn]     = useState('');
  const [pw, setPw]     = useState('');
  const [show, setShow] = useState(false);
  const [err, setErr]   = useState('');
  const [loading, setLoading] = useState(false);

  const go = async () => {
    if (!un.trim() || !pw) { setErr('Enter username and password.'); return; }
    setErr(''); setLoading(true);
    try {
      await login(un.trim(), pw);
      navigate('/vault', { replace: true });
    } catch (e) {
      setErr(e.response?.data?.error || 'Login failed. Check credentials.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'radial-gradient(ellipse 80% 55% at 50% -5%, rgba(59,130,246,.09) 0%, transparent 70%), var(--bg)',
    }}>
      <div style={{
        width: 420, maxWidth: 'calc(100vw - 32px)',
        background: 'var(--s1)', border: '1px solid var(--border2)',
        borderRadius: 14, padding: '44px 40px',
        boxShadow: '0 32px 80px rgba(0,0,0,.55)',
        animation: 'slideUp .28s ease',
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 40 }}>
          <div style={{
            width: 44, height: 44, borderRadius: 12,
            background: 'linear-gradient(135deg,var(--accent),var(--purple))',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22,
            boxShadow: '0 0 28px var(--aglow)',
          }}>🔐</div>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800 }}>
              Vault<span style={{ color: 'var(--accent)' }}>Guard</span>
            </div>
            <div style={{ fontSize: 11, color: 'var(--sub)' }}>Secure Password Manager</div>
          </div>
        </div>

        <h2 style={{ fontSize: 26, fontWeight: 800, marginBottom: 6 }}>Welcome back</h2>
        <p style={{ color: 'var(--sub)', fontSize: 14, marginBottom: 28 }}>Sign in to access your vault</p>

        <div className="field">
          <label className="lbl">Username</label>
          <input
            value={un} onChange={e => setUn(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && go()}
            placeholder="Enter username" autoFocus
          />
        </div>

        <div className="field">
          <label className="lbl">Password</label>
          <div className="pw-wrap">
            <input
              type={show ? 'text' : 'password'}
              value={pw} onChange={e => setPw(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && go()}
              placeholder="••••••••"
            />
            <button className="pw-toggle" onClick={() => setShow(s => !s)}>{show ? '🙈' : '👁'}</button>
          </div>
        </div>

        {err && (
          <div style={{
            background: 'rgba(239,68,68,.1)', border: '1px solid rgba(239,68,68,.28)',
            borderRadius: 'var(--r-sm)', padding: '10px 13px',
            color: '#f87171', fontSize: 13, marginBottom: 16,
          }}>⚠ {err}</div>
        )}

        <button
          className="btn btn-primary"
          style={{ width: '100%', justifyContent: 'center', padding: '12px', fontSize: 14, marginTop: err ? 0 : 8 }}
          onClick={go} disabled={loading}
        >
          {loading ? 'Signing in…' : 'Sign In →'}
        </button>
      </div>
    </div>
  );
}
